import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { ConfirmModal } from "ceco-modal";
import graphql from "babel-plugin-relay/macro";
import { toast } from "react-toastify";

import { commitMutation } from "react-relay";

import environment from "../../../environment";

import { useTranslation } from "ceco-polyglot";

export default function FilterDeleteModal(props) {
  const { trigger, filterName, filterId, refetchData } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState();
  const t = useTranslation();

  function deleteAlert() {
    return new Promise((resolve, reject) => {
      const variables = {
        id: formData.id,
      };

      commitMutation(environment, {
        mutation: FilterDeleteModalMutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  const onSubmit = async () => {
    deleteAlert()
      .then((a) => {
        toast.success(t("message.deleted_filter"));
        setModalOpen(false);
        refetchData();
      })
      .catch((e) => {
        if (Array.isArray(e)) {
          toast.error(e[0].message);
        } else {
          toast.error(e.errors[0].message);
        }
      });
  };
  return (
    <ConfirmModal
      modalOpen={modalOpen}
      title={t("modalTitle.removeFilter")}
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          setFormData({ id: filterId });
        },
      })}
      onClose={() => setModalOpen(false)}
      showCloseButton={true}
      description={
        <div>
          {t("warning.filter_remove", {
            filterName: filterName,
          })}
        </div>
      }
      renderActions={() => (
        <div>
          <Button
            color="red"
            onClick={() => {
              onSubmit();
            }}
          >
            {t("action.delete")}
          </Button>
          <Button
            color="green"
            onClick={() => {
              setModalOpen(false);
            }}
          >
            {t("action.cancel")}
          </Button>
        </div>
      )}
    />
  );
}
const FilterDeleteModalMutation = graphql`
  mutation FilterDeleteModalMutation($id: ID!) {
    labelGroupDelete(input: { id: $id }) {
      deleted
    }
  }
`;
